// extracted by mini-css-extract-plugin
export default {"switch":"toggleSwitch_switch__DS43I","slider":"toggleSwitch_slider__bpvyJ"};